var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: _vm.tagData ? "编辑游戏标签" : "新增游戏标签",
        visible: _vm.visible,
        width: "480px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$emit("update:visible", $event)
        },
        closed: _vm.handleDialogClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "tagFormRef",
          attrs: {
            model: _vm.formData,
            rules: _vm.formRules,
            "label-width": "80px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标签名称", prop: "title" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入标签名称",
                  maxlength: "12",
                  "show-word-limit": "",
                  size: "small",
                },
                model: {
                  value: _vm.formData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "title", $$v)
                  },
                  expression: "formData.title",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "sort" } },
            [
              _c("el-input-number", {
                attrs: {
                  controls: false,
                  min: 1,
                  step: 1,
                  placeholder: "请输入排序",
                  size: "small",
                },
                model: {
                  value: _vm.formData.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sort", $$v)
                  },
                  expression: "formData.sort",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "标签图标" } },
            [
              _c("SingleImageUpload", {
                attrs: { size: 100, tip: "支持 jpg、jpeg、png 格式" },
                model: {
                  value: _vm.formData.image_url,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "image_url", $$v)
                  },
                  expression: "formData.image_url",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 2 },
                model: {
                  value: _vm.formData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "status", $$v)
                  },
                  expression: "formData.status",
                },
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "8px",
                    "font-size": "12px",
                    color: "#999",
                  },
                },
                [_vm._v("关闭后，大厅将不会显示该标签")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", loading: _vm.loading },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }